import React from 'react';
import PropTypes from 'prop-types';

import styles from './playStayStyleBanner.scss';

const MOBILE_MEDIA_QUERY = '(max-width: 1024px)';

const CARDS = [
    {
        id: 'play',
        desktopSrc: '/img/v3/graphics/perks/play-stay-style/play-desktop.png',
        mobileSrc: '/img/v3/graphics/perks/play-stay-style/play-mobile.png',
        alt: 'Play. UTR Sports. $200+ in value. Access world-class analytics that help you understand your game, see your progress, and play smarter.',
    },
    {
        id: 'stay',
        desktopSrc: '/img/v3/graphics/perks/play-stay-style/stay-desktop.png',
        mobileSrc: '/img/v3/graphics/perks/play-stay-style/stay-mobile.png',
        alt: 'Stay. Global Privileges Plus. $250+ in value. Receive up to 60% off 1.4M+ hotels, $100 hotel voucher, airport lounge access, and premium travel perks for tournaments and getaways.',
    },
    {
        id: 'style',
        desktopSrc: '/img/v3/graphics/perks/play-stay-style/style-desktop.png',
        mobileSrc: '/img/v3/graphics/perks/play-stay-style/style-mobile.png',
        alt: 'Style. Fabletics. $1,000+ in value. Enjoy VIP pricing (up to 50% off orders), $100+ per year in rewards, loyalty points, and more (US only).',
    },
];

const PlayStayStyleBanner = ({ onSignInClick }) => (
    <div
        className={styles.banner}
        data-testid="power-perks.play-stay-style-banner.container"
    >
        <div className={styles.cardRow}>
            {CARDS.map(card => (
                <picture
                    key={card.id}
                    data-testid={`power-perks.play-stay-style-banner.card-${card.id}`}
                >
                    <source media={MOBILE_MEDIA_QUERY} srcSet={card.mobileSrc} />
                    <img
                        src={card.desktopSrc}
                        alt={card.alt}
                        className={styles.card}
                    />
                </picture>
            ))}
        </div>
        <button
            type="button"
            className={styles.signInCta}
            onClick={onSignInClick}
            data-testid="power-perks.play-stay-style-banner.sign-in-cta"
        >
            Sign In or Join
        </button>
    </div>
);

PlayStayStyleBanner.propTypes = {
    onSignInClick: PropTypes.func.isRequired,
};

export default PlayStayStyleBanner;
